import { gql } from 'apollo-angular';
export const AwardFragmentDoc = gql`
  fragment Awards on Awards {
    id
    name
    image
    value
    quantity
    category
    reserved
    status
    deletedAt
  }
`;

export const GetAllAwardsDocument = gql`
  query GetAllAwardsGQL{
    getAllAwards{
      ...Awards
    }
  }${AwardFragmentDoc}
`;

export const BuyAwardFragmentDoc = gql`
  fragment BuyAwards on BuyAwards {
    id
  }
`;

export const BuyAwardDocument = gql`
  mutation BuyAwardGQL($data: BuyAwardsInput!){
    buyAwards(data: $data){
      ...BuyAwards
    }
  }${BuyAwardFragmentDoc}
`;

export const SearchAwardsDocument = gql`
    query SearchAwards($input: SearchAwardsInput!) {
  searchAwards(data: $input) {
    ...Awards
  }
}${AwardFragmentDoc}`;